import ReportIssueScreen from '@/src/features/settings/screens/ReportIssueScreen'

export default ReportIssueScreen
